import { Component, Input, OnInit } from '@angular/core';
import { ThemeService } from '../../../shared/theme/services/theme.service';

@Component({
  selector: 'auth-header',
  templateUrl: './auth-header.component.html',
})
export class AuthHeaderComponent implements OnInit {

  @Input() public logoSize: string = 'logo-medium';
  @Input() public guest: boolean = true;

  public theme: string = null;

  public constructor(private themeService: ThemeService) { }

  public ngOnInit() {
    this.theme = this.themeService.theme;
  }

}
